import { doc, FieldPath, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase-config';
import { COLLECTIONS } from '../constants';

export function buildLastReadFieldPath(module, itemKey) {
  return `lastRead.${module}.${itemKey}`;
}

export async function markItemAsRead(userId, module, itemKey) {
  if (!userId || !module || !itemKey) return;

  await updateDoc(
    doc(db, COLLECTIONS.USERS, userId),
    new FieldPath('lastRead', module, itemKey),
    serverTimestamp(),
  );
}

export async function markChatRoomAsRead(userId, unitId) {
  await markItemAsRead(userId, 'chat', unitId);
}
